import { makeStyles, tokens } from '@fluentui/react-components';
import { WifiOff24Regular } from '@fluentui/react-icons';
import { onlineManager } from '@tanstack/react-query';
import { useSyncExternalStore } from 'react';

import { useI18n } from '../lib/i18n/hooks';

const useStyles = makeStyles({
  banner: {
    position: 'sticky',
    top: '40px', // Below the sticky TopBar
    zIndex: 1000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: tokens.spacingHorizontalS,
    width: '100%',
    padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalM}`,
    backgroundColor: '#c50f1f', // Fluent UI red
    color: '#ffffff',
    fontSize: tokens.fontSizeBase300,
    fontWeight: tokens.fontWeightSemibold,
  },
  icon: {
    display: 'flex',
    alignItems: 'center',
  },
});

function useIsOnline(): boolean {
  return useSyncExternalStore(
    (callback) => onlineManager.subscribe(callback),
    () => onlineManager.isOnline(),
    () => true, // SSR fallback - assume online
  );
}

export function OfflineBanner(): React.ReactElement | null {
  const styles = useStyles();
  const isOnline = useIsOnline();
  const { t } = useI18n();

  if (isOnline) {
    return null;
  }

  return (
    <div className={styles.banner} role="alert" aria-live="assertive">
      <span className={styles.icon}>
        <WifiOff24Regular />
      </span>
      <span>{t('offline.banner', 'You are currently offline. Some features may not be available.')}</span>
    </div>
  );
}
